"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFormContext = exports.FormContextProvider = exports.FormContext = void 0;
var react_1 = __importStar(require("react"));
var formik_1 = require("formik");
var FormContext = react_1.default.createContext({}); // eslint-disable-line
exports.FormContext = FormContext;
function FormContextProvider(props) {
    var formId = props.formId, children = props.children;
    var _a = (0, react_1.useState)({}), files = _a[0], setFiles = _a[1];
    var _b = (0, react_1.useState)({}), submitErrors = _b[0], setSubmitErrors = _b[1];
    var setFieldFile = (0, react_1.useCallback)(function (name, file) {
        setFiles(function (prev) {
            var _a;
            return __assign(__assign({}, prev), (_a = {}, _a[name] = file, _a));
        });
    }, []);
    var setSubmitError = (0, react_1.useCallback)(function (name, file) {
        setSubmitErrors(function (prev) {
            var _a;
            return __assign(__assign({}, prev), (_a = {}, _a[name] = file, _a));
        });
    }, []);
    var clearSubmitErrors = (0, react_1.useCallback)(function () {
        setSubmitErrors({});
    }, []);
    var formik = (0, formik_1.useFormikContext)();
    return (react_1.default.createElement(FormContext.Provider, { value: __assign(__assign({}, formik), { files: files, setFieldFile: setFieldFile, formId: formId, submitErrors: submitErrors, setSubmitError: setSubmitError, clearSubmitErrors: clearSubmitErrors }) }, children));
}
exports.FormContextProvider = FormContextProvider;
function useFormContext() {
    return (0, react_1.useContext)(FormContext);
}
exports.useFormContext = useFormContext;
